var exports = {
  "uz": "CustomerStory__POG-Hl",
  "bq": "CustomerStory__logo__AHAvXK",
  "AK": "CustomerStory__logo--flatColour__ObXlCF",
  "G": "CustomerStory--dark__Q4K_vB",
};

module.exports = exports;
